// import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, Navigate } from 'react-router-dom';
// import { MainUrl, signInImage } from '../../../Constant/api';
// import { slugs } from '../../../Constant/slugs';
// import ContactUS from '../../ContactUS';
// // import ForgetPasswordComponent from './ForgetPassword';

// export default function HomeScreenLogin() {
// 	const [userName, setUserName] = React.useState("")
// 	const [password, setPassword] = React.useState("")
// 	const [confirmPassword, setConfirmPassword] = React.useState("")
// 	const [email, setEmail] = React.useState("")
// 	const [PhoneNumber, setPhoneNumer] = React.useState("")

// 	const [reload, setReload] = React.useState(false)
// 	const [passwordShow, setPasswordShow] = React.useState(false)
// 	const [AlertShow, setAlertShow] = React.useState(false)
// 	const [Alertcomp, setAlertcomp] = React.useState("")
// 	const [Register, setRegister] = React.useState(false)
// 	const [loginSuccess, setLoginSuccess] = React.useState(false)
// 	const [forgetPasswordPressed, setForgetPasswordPressed] = React.useState(false)


// 	return (
// 		<div style={{ backgroundColor: "#f2f3f2", minHeight: "100vh", width: "100vw", overflow: 'hidden' }}>
// 			<div className='row'>
// 				<div className="row">
// 					{/* {loginSuccess &&
//           <Navigate to="/" />
//         } */}
// 					<div className="col-lg-2 col-1"></div>
// 					<div className="col-lg-8 col-10 shadow signin-container" style={{ backgroundColor: "#fff" }}>
// 						<div className="py-5">
// 							<div style={{ display: 'flex', justifyContent: 'center', padding: "0 0 50px" }}>
// 								<img
// 									src={signInImage}
// 									height={"100px"}
// 								/>
// 							</div>
// 							<div className='row mt-5'>
// 								<div className="col-lg-3 col-6 mt-5">
// 									<a className="Link" href={MainUrl}>
// 										<div className='center' >
// 											<img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/home.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<span style={{ fontSize: "12px", fontWeight: "bold", margin: "10px" }}>Home</span>
// 										</div>
// 									</a>
// 								</div>
// 								<div className="col-lg-3 col-6 mt-5">
// 									<Link className="Link" to={"/login"}>
// 										<div className=' center'>
// 											<img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/login.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<span style={{ fontSize: "12px", fontWeight: "bold", margin: "10px" }}>Login</span>
// 										</div>
// 									</Link>
// 								</div>
// 								<div className="col-lg-3 col-6 mt-5">
// 									<Link className="Link" to={slugs.free_courses_list}>
// 										<div className='center'>

// 											<img
// 												src="https://api.networkeducationalacademy.com/wp-content/uploads/2026/04/course.png"
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<span style={{ fontSize: "12px", fontWeight: "bold", margin: "10px" }}>Courses</span>
// 										</div>
// 									</Link>
// 								</div>
// 								<div className="col-lg-3 col-6 mt-5">

// 									<Link className="Link" to={slugs.demo_exam}>
// 										<div className=' center' style={{ cursor: "pointer" }}
// 										>
// 											<img src='https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/5231719.png'
// 												style={{ height: "50px", width: "50px" }}
// 											/>
// 											<br />
// 											<span style={{ fontSize: "12px", fontWeight: "bold", margin: "10px" }}>Demo Exam</span>
// 										</div>
// 									</Link>

// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 			<ContactUS />
// 			{reload &&
// 				<div className="modal" style={{ padding: "50vw" }}>
// 					<div className="dot-pulse"></div>
// 				</div>
// 			}

// 		</div>
// 	)
// }



import React from "react";
import { Link } from "react-router-dom";
import {
	MainUrl,
	signInImage,
} from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
import ContactUS from "./ContactUS";
import "./Login.css";

const menuItems = [
	{
		title: "Home",
		description: "Visit our main website",
		image:
			"https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/home.png",
		href: MainUrl,
		external: true,
	},
	{
		title: "Login",
		description: "Sign in to your account",
		image:
			"https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/login.png",
		to: "/login",
	},
	{
		title: "Courses",
		description: "Explore available courses",
		image:
			"https://api.networkeducationalacademy.com/wp-content/uploads/2026/04/course.png",
		to: slugs.free_courses_list,
	},
	{
		title: "Free Exam",
		description: "Practice with free exam",
		image:
			"https://api.aimsintegrationeducation.com.np/wp-content/uploads/2023/07/5231719.png",
		to: slugs.demo_exam,
	},
];

export default function HomeScreenLogin() {
	return (
		<main className="landing-page">
			<section className="landing-hero">
				<div className="landing-logo-wrapper">
					<img
						src={signInImage}
						className="landing-logo"
						alt="Network Educational Academy"
					/>
				</div>

				<div className="landing-heading">
					<span className="landing-badge">
						Network Educational Academy
					</span>

					<h1>Learn, practice and prepare online</h1>

					<p>
						Access courses, practice exams and student
						services from one place.
					</p>
				</div>

				<div className="landing-menu-grid">
					{menuItems.map((item) => {
						const content = (
							<>
								<div className="landing-menu-icon">
									<img src={item.image} alt="" />
								</div>

								<div className="landing-menu-content">
									<h2>{item.title}</h2>
									<p>{item.description}</p>
								</div>

								<span className="landing-menu-arrow">
									→
								</span>
							</>
						);

						if (item.external) {
							return (
								<a
									key={item.title}
									href={item.href}
									className="landing-menu-card"
								>
									{content}
								</a>
							);
						}

						return (
							<Link
								key={item.title}
								to={item.to}
								className="landing-menu-card"
							>
									{content}
							</Link>
						);
					})}
				</div>
			</section>

			<ContactUS />
		</main>
	);
}